import React from 'react';
import { Stack, Divider, List, ListItemButton, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { NavLink } from 'react-router-dom';

type Props = {
  direction: 'row' | 'column',
  onClick?: () => void,
};

const LinkButtons: React.FC<Props> = ({ direction, onClick }) => {

  const LinkButton: React.FC<{ linkTo: string, label: string }> = (
    { linkTo, label }
  ) => {
    const activeStyle: React.CSSProperties = {
      textDecoration: 'none',
      color: '#ffffff',
    };
    const inactiveStyle: React.CSSProperties = {
      textDecoration: 'none',
      color: grey[600],
    };
    const LinkStyle = ({ isActive }: { isActive: boolean }) => (
      isActive ? activeStyle : inactiveStyle
    );

    return (
      <>
        <NavLink to={linkTo} style={LinkStyle}>
          <ListItemButton onClick={onClick}>
            <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
              {label}
            </Typography>
          </ListItemButton>
        </NavLink>
        <Divider />
      </>
    );
  };

  return (
    <List component={Stack} direction={direction}>
      <LinkButton linkTo="/" label="検索" />
      <LinkButton linkTo="about" label="はじめに" />
      <LinkButton linkTo="aboutofm" label="旧枠モダンとは" />
      {/* <LinkButton linkTo="calender" label="イベント" /> */}
      <LinkButton linkTo="history" label="更新履歴" />
    </List>
  );
};

export default LinkButtons;
